import { TNeedleRequestStatus, TStoreNeedleRequest, TTicketNeedleRequest } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableRowNode } from '../../table.type';
import * as moment from 'moment';
import * as _ from 'lodash';

function _formatCategorySubcategory(category: string, subCategory: string | undefined): string[] {
  return subCategory ? [category + ',', subCategory] : [category];
}

export const NEEDLE_REQUESTS_LIST_TABLE_MODEL = {
  createLocalStoreManagerRequestsModel(requests: TTicketNeedleRequest[], status: TNeedleRequestStatus) {
    return ModifiersZTableModel.createTableModel(
      requests,
      {
        padding: 8,
        ...(status === 'PENDING'
          ? {
              select: {
                position: 'START',
                isMulti: true,
                size: 'DEFAULT',
              },
            }
          : {}),
        headerConfig: _.compact([
          {
            type: 'TEXT_CELL',
            text: 'table_model.Date/Time',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.LocationCode',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.MachineSerialId',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.MachineCategory&Sub-Category',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.RequestRaisedby',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.RequestReason',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.Pre-Existing',
            subtitle: {
              text: 'table_model.NeedleNumber|Qty',
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.Requested',
            subtitle: { text: 'table_model.NeedleNumber|Qty' },
          },
          status === 'APPROVED'
            ? {
                type: 'TEXT_CELL',
                text: 'table_model.Approved',
                subtitle: { text: 'table_model.NeedleNumber|Qty' },
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ]),
      },
      (item): TTableRowNode<TTicketNeedleRequest> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: _.compact([
            {
              type: 'TEXT_LIST_CELL',
              text: [
                moment(new Date(item.requestedAt)).format('YYYY/MM/DD'),
                moment(new Date(item.requestedAt)).format('hh:mm A'),
              ],
            },
            {
              type: 'TEXT_CELL',
              text: item.locationInfo.locationDisplayCode,
            },
            {
              type: 'TEXT_CELL',
              text: item.machineDescription.factorySerialNumber,
            },
            {
              type: 'TEXT_LIST_CELL',
              text: _formatCategorySubcategory(
                item.machineDescription.machineCategory,
                item.machineDescription.machineSubCategory,
              ),
            },
            {
              type: 'TEXT_CELL',
              text: item.requestedBy.employeeName,
            },
            {
              type: 'TEXT_CELL',
              text: item.requestReason,
            },
            {
              type: 'TEXT_LIST_CELL',
              text: item.currentNeedles.length
                ? [item.currentNeedles[0].needleNumber, 'Qty : ' + item.currentNeedles[0].quantity]
                : ['--'],
            },
            {
              type: 'TEXT_LIST_CELL',
              text: item.requestedNeedles.length
                ? [item.requestedNeedles[0].needleNumber, 'Qty : ' + item.requestedNeedles[0].quantity]
                : ['--'],
            },
            status === 'APPROVED'
              ? {
                  type: 'TEXT_LIST_CELL',
                  text: item.requestedNeedles.length
                    ? [item.requestedNeedles[0].needleNumber, 'Qty : ' + (item.requestedNeedles[0].approved || 0)]
                    : ['--'],
                }
              : undefined,
            {
              type: 'ACTION_CELL',
              actionType: 'CUSTOM_ACTION',
              customTxt: 'needle_request_expand.Expand',
            },
          ]),
        };
      },
    );
  },

  createGlobalStoreManagerRequestsModel(requests: TStoreNeedleRequest[], status: TNeedleRequestStatus) {
    return ModifiersZTableModel.createTableModel(
      requests,
      {
        padding: 8,
        ...(status === 'PENDING'
          ? {
              select: {
                position: 'START',
                isMulti: true,
                size: 'DEFAULT',
              },
            }
          : {}),
        headerConfig: _.compact([
          {
            type: 'TEXT_CELL',
            text: 'table_model.Date/Time',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.LocationCode',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.RequestRaisedby',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.Requested',
            subtitle: { text: 'table_model.NeedleNumber|Qty' },
          },
          status === 'APPROVED'
            ? {
                type: 'TEXT_CELL',
                text: 'table_model.Approved',
                subtitle: { text: 'table_model.NeedleNumber|Qty' },
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ]),
      },
      (item): TTableRowNode<TStoreNeedleRequest> => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: _.compact([
            {
              type: 'TEXT_LIST_CELL',
              text: [
                moment(new Date(item.requestedAt)).format('YYYY/MM/DD'),
                moment(new Date(item.requestedAt)).format('hh:mm A'),
              ],
            },
            {
              type: 'TEXT_CELL',
              text: item.locationInfo.locationDisplayCode,
            },
            {
              type: 'TEXT_CELL',
              text: item.requestedBy.employeeName,
            },
            {
              type: 'TEXT_LIST_CELL',
              text: [item.requestedNeedles[0].needleNumber, 'Qty : ' + item.requestedNeedles[0].quantity],
            },
            status === 'APPROVED'
              ? {
                  type: 'TEXT_LIST_CELL',
                  text: [item.requestedNeedles[0].needleNumber, 'Qty : ' + (item.requestedNeedles[0].approved || 0)],
                }
              : undefined,
            {
              type: 'ACTION_CELL',
              actionType: 'CUSTOM_ACTION',
              customTxt: 'needle_request_expand.Expand',
            },
          ]),
        };
      },
    );
  },
};
